package tta.destinigo.talktoastro.notification

class JsPermissionManager : NotificationPermissionManager {
    override fun requestPermission(): Boolean {
//        val permission = js("Notification.requestPermission()").unsafeCast<Promise<String>>().await()
//        return permission == "granted"
        // Check if the browser supports notifications
        if (js("window").Notification == null) {
            console.log("This browser does not support notifications.")
            return false
        }

        // Request permission using the Notifications API
//        val permission = Notification.requestPermission().unsafeCast<NotificationPermission>()
//        return permission == "granted"
        return false
    }

    override fun isPermissionGranted(): Boolean {
        return js("Notification.permission") == "granted"
    }
}
